module.exports = __webpack_public_path__ + "static/media/value-to-customer.615b55a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/value-to-customer.svg
// module id = 306
// module chunks = 0